import { render, staticRenderFns } from "./CustomerDetail.vue?vue&type=template&id=4ab24a89&scoped=true"
import script from "./CustomerDetail.vue?vue&type=script&lang=js"
export * from "./CustomerDetail.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetail.vue?vue&type=style&index=0&id=4ab24a89&prod&lang=less&scoped=true"
import style1 from "./CustomerDetail.vue?vue&type=style&index=1&id=4ab24a89&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab24a89",
  null
  
)

export default component.exports